import axios from 'axios';
import type { AxiosRequestConfig, AxiosResponse } from 'axios';
import { ElMessage } from 'element-plus';
import { getToken, removeToken } from '@/utils/auth';
import { notifyAxiosError, rejectBizError } from '@/api/http-error';

export interface HttpResponse<T = unknown> {
  status: number;
  message: string;
  code: number;
  data: T;
}

const service = axios.create({
  baseURL: '', // url = base url + request url
  timeout: 30000 // request timeout
})

if (process.env.VUE_APP_API_BASE_SSO_URL) {
  service.defaults.baseURL = process.env.VUE_APP_API_BASE_SSO_URL;
}

service.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    // let each request carry token
    // this example using the JWT token
    // Authorization is a custom headers key
    // please modify it according to the actual situation
    const token = getToken();

    if (token) {
      if (!config.headers) {
        config.headers = {};
      }
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    // do something
    return Promise.reject(error);
  }
);
// add response interceptors
service.interceptors.response.use(
  (response: AxiosResponse<HttpResponse>) => {
    const res = response.data;

    if (res.code !== 200) {
      if (res.code === 401) {
        ElMessage.error({
          message: '登录超时，请重新登录',
          duration: 2 * 1000,
          onClose: () => {
            removeToken();
            window.location.reload();
          },
        });
      } else {
        return rejectBizError(res.message || 'Error');
      }
    }
    return res;
  },
  (error) => notifyAxiosError(error)
);

export default service
